import styled from 'styled-components';

export const DragButton = styled.div<{ isDragging: boolean | undefined }>`
  cursor: ${({ isDragging }) => (isDragging ? 'grabbing' : 'grab')};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  font-size: 16px;
  color: #888;
  transition: color 0.3s;

  &:hover {
    color: #555;
    transform: scale(1.2);
  }
`;
